export const HALLUCINATION_RISK_MSG =
  "WITHHELD: No Anchor - Hallucination Risk Detected. Attach a source anchor to release output.";